import { getImagesUrls } from "../utils/s3Utils.js";
import capitalizeFirstLetter from "../utils/strings.js";

//GET URL PRESIGNED OF IMAGES
//dict with images key routes of the page
const imageskeyRoutes = {
  s3clickCollectIcon: "assets/icons/click-and-collect.png",
  s3fulfillmentIcon: "assets/icons/fulfillment.png",
  s3payCollectIcon: "assets/icons/pay-and-collect.png",
  s3deliveryIcon: "assets/icons/delivery.png",
};

const imageUrls = await getImagesUrls(imageskeyRoutes, "enums");

export const orderStatusEnum = [
  { value: "in_preparation", label: "En preparación" },
  { value: "pending_assignment", label: "Pendiente de asignación" },
  { value: "assigned", label: "Asignado" },
  { value: "pick_up_ready", label: "Listo para retirar" },
  { value: "completed", label: "Completado" },
];

export const orderSourceEnum = [
  { value: "excel", label: "Excel" },
  { value: "single_form_upload", label: "Single Form Upload" },
  { value: "shopify", label: "Shopify" },
  { value: "meli", label: "Mercado Libre" },
  { value: "meli_flex", label: "Mercado Libre Flex" },
  { value: "meli_places", label: "Mercado Libre Places" },
  { value: "meli_collect", label: "Mercado Libre Colecta" },
  { value: "meli_full", label: "Mercado Libre Full" },
  { value: "woocommerce", label: "Woocommerce" },
  { value: "bootic", label: "Bootic" },
  { value: "vtex", label: "VTex" },
  { value: "prestashop", label: "Prestashop" },
  { value: "api", label: "API" },
  { value: "not_selected", label: "Origen desconocido" },
];

export const deliveryStatusEnum = [
  { value: "pending", label: "Pendiente" },
  { value: "created_on_courier", label: "Creado en courier" },
  { value: "fulfilled", label: "Preparado" },
  { value: "withdrawn", label: "Retirado" },
  { value: "in_transit", label: "En tránsito" },
  { value: "in_cd", label: "En CD" },
  { value: "dropped_at_hub", label: "Dejado en hub" },
  { value: "on_the_way", label: "En camino" },
  { value: "ready_for_pickup", label: "Listo para retiro" },
  { value: "delivered", label: "Entregado" },
  { value: "failed", label: "Fallido" },
  { value: "returning", label: "En devolución" },
  { value: "returned", label: "Devuelto" },
  { value: "damaged", label: "Siniestrado" },
  { value: "compensated", label: "Indemnizado" },
  { value: "cancelled", label: "Cancelado" },
  { value: "waiting_for_assignment", label: "Por asignar" },
  { value: "packed", label: "Pedido armado" },
];

export const deliverySubstatusEnum = [
  { value: "not_specified", label: "No aplica" },
  { value: "delivered_partial", label: "Parcial" },
  { value: "delivered_complete", label: "Completo" },
  { value: "failed_rejected", label: "Rechazado" },
  { value: "failed_incomplete_address", label: "Dirección Incompleta" },
  { value: "failed_absent_client", label: "Cliente ausente" },
  { value: "failed_nonexisting_address", label: "Dirección no existe" },
  { value: "failed_out_of_range", label: "Sin cobertura" },
  { value: "failed_bad_data", label: "Datos erróneos" },
  { value: "failed_product_not_match", label: "Producto no corresponde" },
  { value: "failed_rescheduled", label: "Reprogramado" },
  { value: "failed_route_pending", label: "Pendiente de ruta" },
  { value: "failed_out_of_schedule", label: "Fuera de horario" },
  { value: "damaged_spoiled_package", label: "Embalaje dañado" },
  { value: "damaged_missing_package", label: "Extraviado" },
  { value: "damaged_spoiled_content", label: "Contenido dañado" },
  { value: "withdrawn_internal_reader", label: "Gestión interna" },
  { value: "withdrawn_external_reader", label: "Gestión externa" },
];

export const activeStatusToEditItems = [
  "pending",
  "created_on_courier",
  "waiting_for_assignment",
  "fulfilled",
  "packed",
];


export const mapSubtatusToDbName = (substatus) => {
  switch (substatus) {
    case "not_specified":
      return "not_specified";
    case "partial":
      return "partial";
    case "complete":
    case "delivered_partial":
      return "partial";
    case "delivered_complete":
      return "complete";
    case "failed_rejected":
      return "rejected";
    case "failed_incomplete_address":
      return "incomplete_address";
    case "failed_absent_client":
      return "absent_client";
    case "failed_nonexisting_address":
      return "nonexisting_address";
    case "failed_out_of_range":
      return "out_of_range";
    case "failed_bad_data":
      return "bad_data";
    case "failed_product_not_match":
      return "product_not_match";
    case "failed_rescheduled":
      return "rescheduled";
    case "failed_route_pending":
      return "route_pending";
    case "failed_out_of_schedule":
      return "out_of_schedule";
    case "failed_not_delivered":
      return "not_delivered";
    case "damaged_spoiled_package":
      return "spoiled_package";
    case "damaged_missing_package":
      return "missing_package";
    case "damaged_spoiled_content":
      return "spoiled_content";
    case "withdrawn_internal_reader":
      return "internal_reader";
    case "withdrawn_external_reader":
      return "external_reader";
    default:
      break;
  }
};

export const orderTypeEnum = [
  {
    label: "Click & Collect",
    value: "click_collect",
    icon: imageUrls.s3clickCollectIcon,
  },
  { label: "Delivery", value: "delivery", icon: imageUrls.s3deliveryIcon },
  {
    label: "Delivery Fulfillment",
    value: "delivery_fulfillment",
    icon: imageUrls.s3deliveryIcon,
  },
  {
    label: "Pay & Collect",
    value: "pay_collect",
    icon: imageUrls.s3payCollectIcon,
  },
  {
    label: "Pick Up Fulfillment",
    value: "pick_up_fulfillment",
    icon: imageUrls.s3payCollectIcon,
  },
  { label: "Pick Up", value: "pick_up", icon: imageUrls.s3payCollectIcon },
  {
    label: "Devolución",
    value: "delivery_return",
    icon: imageUrls.s3payCollectIcon,
  },
];

export const shippingMethodEnum = [
  { label: "Envío RM Same day", value: "rm_same_day" },
  { label: "Envío RM Next day", value: "rm_next_day" },
  { label: "Envío Meli", value: "meli" },
  { label: "Envío Meli Flex", value: "meli_flex" },
  { label: "Envío Meli Places", value: "meli_places" },
  { label: "Envío Región", value: "region" },
  { label: "Pick Up Blue Express", value: "pick_up_bluex" },
  { label: "Pick Up Go Ex", value: "pick_up_goex" },
  { label: "Devolución Blue Express", value: "devolution_bluex" },
  { label: "Envío Express", value: "express" },
  { label: "Envío Same day", value: "same_day" },
  { label: "Envío Regional", value: "regional" },
  { label: "Envío RM Rural", value: "rm_rural" },
  { label: "Envío a Punto de Distribución", value: "pod" },
  { label: "No Seleccionado", value: "not_selected" },
];

export const shippingMethodEnumChoices = [
  { label: "Envío Express", value: "express" },
  { label: "Envío Same day", value: "same_day" },
  { label: "Envío Regional", value: "regional" },
  { label: "Envío RM Rural", value: "rm_rural" },
  { label: "Envío a Punto de Distribución", value: "pod" },
];

export const pickUpMethodEnum = [
  { label: "Pickup punto Go-ex", value: "pick_up_goex" },
  { label: "Pickup punto Blue-ex", value: "pick_up_bluex" },
];

export const courierPlan = [
  { label: "Delivery", value: "delivery" },
  // {label: 'Omnichannel', value: 'omnichannel'},
  // {label: 'Full Omnichanel', value: 'full_omnichannel'},
];

export const driversChoices = (drivers) =>
  drivers.map((driver) => ({ label: driver.full_name, value: driver.id }));

export const get_order_type_label = (order_type) => {
  const order_type_obj = orderTypeEnum.find(
    (order_type_obj) => order_type_obj.value === order_type
  );
  return order_type_obj ? order_type_obj.label : "";
};

export const get_order_shipping_method_label = (shipping_method) => {
  const shipping_method_obj = shippingMethodEnum.find(
    (shipping_method_obj) => shipping_method_obj.value === shipping_method
  );
  return shipping_method_obj ? shipping_method_obj.label : "";
};

export const get_order_provider = (order_delivery) => {
  if (
    order_delivery.shipping_method === "pick_up_bluex" ||
    order_delivery.shipping_method === "devolution_bluex"
  ) {
    return "Bluex";
  } else {
    return capitalizeFirstLetter(order_delivery?.shipping_zone?.courier) ?? "-";
  }
};

export const get_order_status_label = (order_status, order_type) => {
  if (order_status === "pending_assignment" && order_type === "click_collect") {
    return "Listo para Retirar"; // Solución parche
  }
  const order_status_obj = orderStatusEnum.find(
    (order_status_obj) => order_status_obj.value === order_status
  );
  if (order_status_obj) {
    return order_status_obj.label;
  } else {
    const delivery_status_obj = deliveryStatusEnum.find(
      (delivery_status_obj) => delivery_status_obj.value === order_status
    );
    return delivery_status_obj ? delivery_status_obj.label : "";
  }
};

export const get_order_source_label = (order_source) => {
  const order_source_obj = orderSourceEnum.find(
    (order_source_obj) => order_source_obj.value === order_source
  );
  return order_source_obj ? order_source_obj.label : "";
};

export const get_seller_plan = (seller_plan) => {
  const plan_type_obj = courierPlan.find(
    (plan_type_obj) => plan_type_obj.value === seller_plan
  );
  return plan_type_obj ? plan_type_obj.label : "";
};
